function useURLSearchParam (param) {
  const search = new URLSearchParams(window.location.search);
  return search.get(param);
}

export default useURLSearchParam;
